import { useEffect, useState } from "react";
import { Button, Table, Modal, Form, Input } from "rsuite";
import axios from "axios";
import { config } from "../../data/config";
import { getCookies } from "cookies-next";
import BreadCrump from "../tools/breadcrump";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from 'react-i18next';

export default function PostShop() {
    const { t } = useTranslation();

    const [postMethods, setPostMethods] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newPostMethod, setNewPostMethod] = useState({ _id: '', name: '', text: '', limitweight: 0, price: 0 });
    let cookie = getCookies();

    useEffect(() => {
        loaditem();
    }, []);
    const loaditem = () => {
        axios.get(config.url + '/v1/dashboard/postmethods', {
            headers: {
                Authorization: 'Bearer ' + cookie['token'],
            }
        })
            .then(response => setPostMethods(response.data.message))
            .catch(error => console.error(error));
    }
    const handleAdd = () => {
        setShowModal(true);
    };

    const handleSave = () => {
        if (newPostMethod._id == "") {
            axios.post(config.url + '/v1/dashboard/postmethods', newPostMethod, {
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            })
                .then(response => {
                    setPostMethods(response.data);
                    setNewPostMethod({ _id: '', name: '', text: '', limitweight: 0, price: 0 }); // Clear form
                    setShowModal(false);
                    loaditem();
                })
                .catch(error => console.error(error));

        } else {
            axios.put(config.url + '/v1/dashboard/postmethods/' + newPostMethod._id, newPostMethod, {
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            })
                .then(response => {
                    setPostMethods(response.data);
                    setNewPostMethod({ _id: '', name: '', text: '', limitweight: 0, price: 0 }); // Clear form
                    setShowModal(false);
                    loaditem();
                })
                .catch(error => console.error(error));
        }







    };

    const handleRemove = (id: any) => {
        // Remove logic here
    };

    const handleDelete = (id: any) => {
        axios.delete(config.url + '/v1/dashboard/postmethods/' + id, {
            headers: {
                Authorization: 'Bearer ' + cookie['token'],
            }
        })
            .then(response => loaditem())
            .catch(error => console.error(error));
    };

    const handleEdit = (postMethod: any) => {
        setNewPostMethod(postMethod);
        setShowModal(true);
    };

    const breadcrump = [
        {
            name: 'داشبورد',
            url: '/dashboard'
        },

        {
            name: 'تنظیمات فروش',
            url: '/dashboard/shop'
        },
        {
            name: 'پست',
            url: null
        },
    ]
    return (
        <div>
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="نحوه ارسال"></HeaderOfPage>

            <div className="flex flex-row gap-0 pt-4 pb-4">
                <Button color={`blue`} onClick={handleAdd}>اضافه کردن مدل پست</Button>

            </div>
            {
                postMethods.length > 0 && <table className="min-w-full divide-y divide-gray-200 text-right">
                    <thead>
                        <tr>
                            <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('Name')}  </th>
                            <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('متن')}</th>
                            <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase  ">{t('حداکثر وزن')} </th>
                            <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('قیمت')}</th>
                            <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('عملیات')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {postMethods != null && postMethods.map((item: any) => {
                            return (
                                <tr className="odd:bg-white even:bg-gray-100 hover:bg-gray-100  ">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 ">{item.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">{item.text}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">{item.limitweight}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">{item.price}</td>

                                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-2">
                                        <Button size={`sm`} onClick={() => handleEdit(item)}>
                                            <img src="/icons/editgreen.svg" width={20} alt="Edit" />

                                        </Button>
                                        <Button size={`sm`} onClick={() => handleDelete(item.id)}>
                                            <img src="/icons/delred.svg" width={20} alt="Del" />
                                        </Button>

                                    </td>

                                </tr>
                            )
                        })}



                    </tbody>

                </table>
            }
         
            <Modal open={showModal} onClose={() => setShowModal(false)}>
                <Modal.Header>
                    <Modal.Title>اضافه کردن مدل پست جدید</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form fluid>
                        <div className="flex flex-col gap-3">
                            <label>نام</label>
                            <Input name="name" value={newPostMethod.name} onChange={(value: any) => setNewPostMethod({ ...newPostMethod, name: value })} />

                            <label>متن</label>
                            <Input name="text" value={newPostMethod.text} onChange={(value: any) => setNewPostMethod({ ...newPostMethod, text: value })} />
                            <label>حداکثر وزن</label>
                            <Input dir="ltr" name="number" value={newPostMethod.limitweight} onChange={(value: any) => setNewPostMethod({ ...newPostMethod, limitweight: value })} />
                            <label>قیمت</label>
                            <Input dir="ltr" name="number" value={newPostMethod.price} onChange={(value: any) => setNewPostMethod({ ...newPostMethod, price: value })} />
                        </div>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleSave} appearance="primary">ذخیره</Button>
                    <Button onClick={() => setShowModal(false)} appearance="subtle">لغو</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}